import { render, staticRenderFns } from "./ShopBundleDiscountList.vue?vue&type=template&id=1052cd5e"
import script from "./ShopBundleDiscountList.vue?vue&type=script&lang=js"
export * from "./ShopBundleDiscountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports